import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

class ShopEventTab {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      type: 'fade',
      rewind: false,
      perPage: 1,
      // autoWidth: true,
      // autoHeight: true,
      gap: ((25 / 375) * 100) + 'vw',
      speed: 0,
      // width: '80%',
      // focus: 'center',
      arrows: true,
      pagination: false,
      lazyLoad: 'nearby',
      // drag: false,
      // items:PaginationItem[]
      mediaQuery: 'min',
      breakpoints: {
        768: {
          // type: 'loop',
          gap: `min(${48 / 16}rem, ${48 / 1440 * 100}vw)`,
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default ShopEventTab